/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FlattenedOrderStatuses =
  | 'completed'
  | 'delivering'
  | 'failed'
  | 'preparing'
  | 'readyForCourier'
  | 'received';

export type HomePendingFeedbackOrderQueryVariables = Exact<{
  orderId: string | number;
}>;

export type HomePendingFeedbackOrderQuery = {
  readonly orderStatus:
    | { readonly __typename: 'InvalidOrder' }
    | {
        readonly __typename: 'OrderStatus';
        readonly flattenedOrderStatus: Types.FlattenedOrderStatuses;
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly isPendingFeedback: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly asset: { readonly url: string };
            };
          }>;
        };
      }
    | null;
};

export const HomePendingFeedbackOrderDocument = gql`
  query HomePendingFeedbackOrder($orderId: ID!) {
    orderStatus(orderId: $orderId) {
      __typename
      ... on OrderStatus {
        flattenedOrderStatus
        order {
          id
          __typename
          wantedTime
          isPendingFeedback
          lineItems {
            id
            __typename
            product {
              id
              __typename
              asset {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export function useHomePendingFeedbackOrderQuery(
  options: Omit<Urql.UseQueryArgs<HomePendingFeedbackOrderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HomePendingFeedbackOrderQuery, HomePendingFeedbackOrderQueryVariables>({
    query: HomePendingFeedbackOrderDocument,
    ...options,
  });
}
